module.exports = __webpack_public_path__ + "img/75.7101ac0d.jpg";